import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class FieldsBlocQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.FIELDS_BLOC;
  type: string;
  repetitions: Array<any>;

  constructor(options: any = {}) {
    super(options);
    this.type = options['type'] || 'fields-block';
    this.repetitions = options['repetitions'];
  }
}
